import { Box } from '@mui/material'
import './pageContentWrapper.css'

const PageContentWrapper = (props) => {
	return (
		<Box className={'pageContentWrapper'}>
			{props.children}
		</Box>
	)
}

export default PageContentWrapper